import WebinarsApi from '@/api/webinars';

export default {
  namespaced: true,
  state: {
    scheduledWebinars: [],
    pastWebinars: [],
  },

  mutations: {
    SET_SCHEDULED_WEBINARS(state, val) {
      state.scheduledWebinars = val;
    },
    SET_PAST_WEBINARS(state, val) {
      state.pastWebinars = val;
    },

  },
  actions: {
    async getWebinars({ commit }) {
      // eslint-disable-next-line no-useless-catch
      try {
        const webinars = await WebinarsApi.getWebinars();
        commit('SET_SCHEDULED_WEBINARS', webinars.data.scheduled_webinars);
        commit('SET_PAST_WEBINARS', webinars.data.past_webinars);
        return webinars;
      } catch (e) {
        throw e;
      }
    },
  },

};
